import { Injectable } from '@angular/core';
import { PreloadingStrategy, Router } from '@angular/router';
import { Observable, of } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class PreloadingStrategyService implements PreloadingStrategy {
    constructor(private router: Router) {}

    preload(route: any, load: () => Observable<any>): Observable<any> {
        // Preload the module only if data.preload is true and preloadPath is equal to current url
        if (route.data) {
            const { preloadPaths } = route.data;
            const currentUrlWithoutParams = this.router.url.split('?')[0].slice(1);

            if (preloadPaths?.length && preloadPaths.includes(currentUrlWithoutParams)) {
                return load();
            } else {
                return of(null);
            }
        }

        return of(null);
    }
}
